module.exports = __webpack_public_path__ + "static/img/texto_parceria.7313b58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/texto_parceria.svg
// module id = 1815
// module chunks = 1